import * as exElement from '../../../utils/element';

import type { Context } from '../types';

// ----------------------------------------------------------------------------

function listing(ctx: Context): any {
    ctx.shared.elements.listing = {};

    function init(): void {
        create();
    }

    // ------------------------------------------------------------------------

    function create(): void {
        // Create element (select listing)
        const elSelectListing = exElement.create({
            merge: ctx.shared.config.listing,
            class: {
                new: 'select-listing',
            },
        });
        ctx.shared.elements.dropdown.element.appendChild(elSelectListing);
        ctx.shared.elements.listing.element = elSelectListing;

        // Add class (select single or multi)
        elSelectListing.addClass('select-' + ctx.shared.config.type);

        // --------------------------------------------------------------------

        // Create element (dropdown menu)
        const elDropdownMenu = exElement.create({
            tag: 'ul',
            class: {
                new: 'dropdown-menu',
            },
        });
        elSelectListing.appendChild(elDropdownMenu);
        ctx.shared.elements.listing.dropdown = elDropdownMenu;
    }

    // ------------------------------------------------------------------------

    function clear(): void {
        ctx.shared.elements.listing.dropdown.innerHTML = '';
    }

    // ------------------------------------------------------------------------

    function getElement(): HTMLElement {
        return ctx.shared.elements.listing.element;
    }

    function getDropdownElement(): HTMLElement {
        return ctx.shared.elements.listing.dropdown;
    }

    // ------------------------------------------------------------------------

    return {
        init,
        create,
        clear,
        getElement,
        getDropdownElement,
    };
}

// ----------------------------------------------------------------------------

export default listing;
